var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBot = function SvgBot(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18181B",
    fillRule: "evenodd",
    d: "M10.834 1.667a.833.833 0 1 0-1.667 0V5h-1c-1.39 0-2.29 0-3.045.245a5 5 0 0 0-3.21 3.21c-.246.755-.245 1.655-.245 3.046v.332c0 1.391 0 2.29.245 3.046a5 5 0 0 0 3.21 3.21c.755.245 1.655.245 3.045.245h3.666c1.391 0 2.29 0 3.046-.245a5 5 0 0 0 3.21-3.21c.245-.755.245-1.655.245-3.046v-.332c0-1.391 0-2.29-.245-3.046a5 5 0 0 0-3.21-3.21C14.124 5 13.224 5 11.833 5h-1V1.667ZM5.75 10.833a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Zm5 0a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBot);
export default ForwardRef;